import classnames from 'classnames';
import React, { forwardRef, useCallback } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, disabled = false, type, ...inputProps }, ref) => {
    const handleOnWheel = useCallback(
      (event: React.WheelEvent<HTMLInputElement>) => {
        if (type === 'number' && event.target === document.activeElement) {
          (event.target as HTMLInputElement).blur();
        }
      },
      [type]
    );

    return (
      <input
        ref={ref}
        className={classnames(
          'DSInput input-reset ba br3 b--default pl4 pr4 pt3 pb3 font-16',
          className
        )}
        disabled={disabled}
        type={type}
        onWheel={handleOnWheel}
        {...inputProps}
      />
    );
  }
);

Input.displayName = 'DSInput';

export default Input;
